// @ts-nocheck

import { request } from '../../../../../../../context';
import type { ApiOptions } from '../../../../../../../context';
import type {
    DeleteReviewIntelligentPartnerNodeInputSceneConfigManageDeleteSceneByIdByIdParam,
    BaseResponseVoid,
} from '../../../../../../../types';

/**
 * deleteSceneById
 *
 * @export
 * @tags 智能陪练-AI输入场景节点配置
 * @link [DELETE] /review/intelligentPartner/node/inputSceneConfig/manage/deleteSceneById/{id}
 * @param id
 */
export function deleteReviewIntelligentPartnerNodeInputSceneConfigManageDeleteSceneByIdById(
    options: ApiOptions<
        DeleteReviewIntelligentPartnerNodeInputSceneConfigManageDeleteSceneByIdByIdParam,
        never
    > & {
        segments: DeleteReviewIntelligentPartnerNodeInputSceneConfigManageDeleteSceneByIdByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<
        never,
        DeleteReviewIntelligentPartnerNodeInputSceneConfigManageDeleteSceneByIdByIdParam,
        never
    >('/review/intelligentPartner/node/inputSceneConfig/manage/deleteSceneById/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName:
            'deleteReviewIntelligentPartnerNodeInputSceneConfigManageDeleteSceneByIdById',
    });
}

export const meta = [
    {
        tags: ['智能陪练-AI输入场景节点配置'],
        path: '/review/intelligentPartner/node/inputSceneConfig/manage/deleteSceneById/{id}',
        method: 'delete',
    },
];
